<!-- src/routes/(app)/(platform)/+page.svelte -->
<script lang="ts">
	import Plans from '$lib/components/sections/Plans.svelte';
	import About from '$lib/components/sections/About.svelte';
	import KnowledgeBase from '$lib/components/sections/KnowledgeBase.svelte';
	import Header from '$lib/components/platform/pages/home/Header.svelte';
	import TrustedPartners from '$lib/components/sections/TrustedPartners.svelte';
	import Benefits from '$lib/components/sections/Benefits.svelte';
	import Meta from '$lib/components/Meta.svelte';
	import Livestream from '$lib/components/sections/Livestream.svelte';
	import VimeoCarousel from '$lib/components/VimeoCarousel.svelte';

	export let data;
</script>

<Meta title={data.page.title} description={data.page.description} image={data.page.public_image_url}
></Meta>

<Header></Header>

<main>
	<div class="-mt-32 space-y-20 bg-white px-8 pb-36 md:-mt-56 md:space-y-36 md:px-16">
		{#each data.homepagePlaylists as playlist, index}
			{#if playlist}
				<VimeoCarousel
					title={playlist.name}
					titleColor={index === 0 ? 'text-white' : undefined}
					videos={playlist.videos}
					{playlist}
				/>
			{/if}
		{/each}
	</div>

	<Livestream class="min-h-[95svh]" />

	<Plans
		memberships={data.memberships}
		title="Start Your <br>Never Stop Learning&trade; <br>Journey Today!"
	/>

	<About class="min-h-[95svh]" />

	<Benefits data={data.benefits} />
	<KnowledgeBase knowledgeBasePage={data.knowledgebasePage} />

	<TrustedPartners partners={data.partners} />
</main>
